import { createFileRoute } from '@tanstack/react-router'
import SettingsWebhooksPage from '@/components/pages/Settings/team/SettingsWebhooksPage/SettingsWebhooksPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/webhooks')({
  component: WebhooksSettingsRoute,
})

function WebhooksSettingsRoute() {
  return <SettingsWebhooksPage />
}
